<script>
  import Image from "../ToolBox/Image.svelte";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";

  export let data;
  data.style.color = data.style.color || "#ffffff";
</script>

<div class="col20 f-left color-pick-wrap-widgets">
  <ColorPicker bind:color={data.style.color} label="Box Background Color" alpha="no" />
</div>

<Image bind:data={data.left} disable={["link", "fullscreen", "width"]} customName="Testimonial 1" />
<Image bind:data={data.right} disable={["link", "fullscreen", "width"]} customName="Testimonial 2" />
<BlockGlobal bind:data isCollapsable={true} isCollapsed={true} />
